(function () {
  const picker = document.querySelector('.value-pack-picker');
  if (!picker) return;

  const REQUIRED = Number(picker.dataset.requiredTotal || 10);
  const form = picker.closest('form');
  if (!form) return;

  const msg = picker.querySelector('.vp-message');
  const inputs = Array.from(picker.querySelectorAll('.vp-input'));
  const plusBtns = Array.from(picker.querySelectorAll('.vp-plus'));

  const purchaseButtons = Array.from(
    document.querySelectorAll(
      'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"], .shopify-payment-button__button'
    )
  );

  function totalSelected() {
    return inputs.reduce((sum, i) => sum + (Number(i.value) || 0), 0);
  }

  function ensureHiddenProperty(key) {
    const name = `properties[${key}]`;
    let el = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.value = '0';
      form.appendChild(el);
    }
    return el;
  }

  function syncProperties() {
    inputs.forEach(i => {
      const key = i.dataset.flavour;
      const val = String(Number(i.value) || 0);
      ensureHiddenProperty(key).value = val;
    });
  }

  function setPurchaseEnabled(enabled) {
    purchaseButtons.forEach(btn => {
      if ('disabled' in btn) btn.disabled = !enabled;
      btn.setAttribute('aria-disabled', (!enabled).toString());
      btn.style.pointerEvents = enabled ? '' : 'none';
      btn.style.opacity = enabled ? '1' : '0.6';
    });
  }

  function updateUI() {
    const total = totalSelected();
    syncProperties();

    // Disable all "+" when total is full (this prevents adding NEW flavours after 10)
    plusBtns.forEach(b => { b.disabled = total >= REQUIRED; });

    const valid = total === REQUIRED;
    setPurchaseEnabled(valid);

    if (msg) {
      if (valid) {
        msg.textContent = `✓ ${REQUIRED} packs selected`;
        msg.style.color = '#1a7f37';
      } else {
        const remaining = REQUIRED - total;
        msg.textContent = remaining > 0
          ? `Select ${remaining} more pack${remaining === 1 ? '' : 's'}`
          : `Remove ${Math.abs(remaining)} pack${Math.abs(remaining) === 1 ? '' : 's'}`;
        msg.style.color = '#b00020';
      }
    }
  }

  picker.addEventListener('click', function (e) {
    const plus = e.target.closest('.vp-plus');
    const minus = e.target.closest('.vp-minus');
    if (!plus && !minus) return;

    e.preventDefault();
    e.stopPropagation();

    const flavour = (plus || minus).dataset.flavour;
    const input = picker.querySelector(`.vp-input[data-flavour="${CSS.escape(flavour)}"]`);
    if (!input) return;

    let current = Number(input.value || 0);

    if (plus) {
      if (totalSelected() >= REQUIRED) return updateUI();
      current += 1;
    } else {
      current -= 1;
    }

    current = Math.max(0, Math.min(10, current));
    input.value = String(current);
    updateUI();
  });

  form.addEventListener('submit', function (e) {
    if (totalSelected() !== REQUIRED) {
      e.preventDefault();
      e.stopPropagation();
      updateUI();
      return false;
    }
    syncProperties();
  }, true);

  purchaseButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      if (totalSelected() !== REQUIRED) {
        e.preventDefault();
        e.stopPropagation();
        updateUI();
        return false;
      }
      syncProperties();
    }, true);
  });

  updateUI();
})();
